import type { SignInput } from './index';

export type SignRequest = {
  inputs: SignInput[],
};